(() => {
  if (window.replicaCartController) return;
  window.replicaCartController = true;
  let busy = false, opener;
  const drawer = () => document.querySelector('.replica-cart-controller');
  const cartURL = () => drawer()?.dataset.cartUrl || '/cart';
  const isCartTrigger = (target) => {
    if (target.matches('#cart-icon-bubble, .replica-header__cart, [data-replica-cart-open]')) return true;
    if (!target.matches('a.pmh-icon')) return false;
    const link = new URL(target.href, location.origin);
    return link.origin === location.origin && link.pathname.replace(/\/$/, '') === cartURL().replace(/\/$/, '');
  };
  const stop = (event) => { event.preventDefault(); event.stopImmediatePropagation(); };
  const close = () => {
    drawer()?.classList.remove('active', 'animate');
    document.body.classList.remove('overflow-hidden');
    opener?.focus();
  };
  const open = (trigger) => {
    if (trigger instanceof HTMLElement) opener = trigger;
    drawer()?.classList.add('active', 'animate');
    document.body.classList.add('overflow-hidden');
    drawer()?.querySelector('.replica-drawer__close')?.focus();
  };
  const showError = (error) => {
    const node = drawer()?.querySelector('#CartDrawer-CartErrors');
    if (node) node.textContent = error.message || 'Unable to update your bag. Please try again.';
  };
  const loadRecommendations = async (container = drawer()) => {
    const rail = container?.querySelector('[data-recommendation-rail]');
    if (!rail || rail.querySelector('.replica-drawer__card') || rail.dataset.loading === 'true') return;
    rail.dataset.loading = 'true';
    rail.textContent = 'Loading products…';
    try {
      const prefix = cartURL().replace(/\/cart\/?$/, '');
      const response = await fetch(prefix + '/collections/all/products.json?limit=12', { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Products could not be loaded.');
      const data = await response.json();
      const products = (data.products || []).filter(product => !/membership/i.test(product.handle)).slice(0, 6);
      rail.textContent = '';
      const currency = rail.dataset.currency || window.Shopify?.currency?.active || 'USD';
      const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(Number(value));
      const element = (tag, className, text) => {
        const node = document.createElement(tag); node.className = className;
        if (text !== undefined) node.textContent = text;
        return node;
      };
      for (const product of products) {
        const variant = product.variants?.find(value => value.available) || product.variants?.[0];
        if (!variant) continue;
        const card = element('article', 'replica-drawer__card');
        const url = prefix + '/products/' + encodeURIComponent(product.handle);
        const media = element('a', 'replica-drawer__card-media'); media.href = url;
        if (product.images?.[0]?.src) {
          const image = element('img', 'replica-drawer__card-image');
          image.src = product.images[0].src; image.alt = product.title; image.loading = 'lazy';
          media.append(image);
        }
        const title = element('a', 'replica-drawer__card-title', product.title); title.href = url;
        const prices = element('div', 'replica-drawer__card-prices');
        const original = Number(variant.compare_at_price) > Number(variant.price) ? variant.compare_at_price : variant.price;
        prices.append(element('s', '', money(original)), element('span', '', money(variant.price)));
        const form = element('form', 'replica-drawer__add-form');
        form.method = 'post'; form.action = cartURL() + '/add'; form.dataset.replicaDrawerAdd = '';
        const id = document.createElement('input'); id.type = 'hidden'; id.name = 'id'; id.value = variant.id;
        const button = element('button', '', variant.available ? 'ADD · ' + money(variant.price) : 'Sold out');
        button.type = 'submit'; button.disabled = !variant.available;
        form.append(id, button); card.append(media, title, prices, form); rail.append(card);
      }
      if (!rail.children.length) rail.textContent = 'No products available.';
    } catch (error) {
      rail.textContent = 'Unable to load products. ';
      const retry = document.createElement('button');
      retry.type = 'button'; retry.textContent = 'Retry'; retry.dataset.recommendationsRetry = '';
      rail.append(retry);
    } finally { delete rail.dataset.loading; }
  };
  const updateCount = (cart) => {
    document.querySelectorAll('[data-pmh-count]').forEach((badge) => {
      badge.textContent = String(cart.item_count);
      badge.hidden = cart.item_count === 0;
    });
    document.querySelectorAll('#cart-icon-bubble, .replica-header__cart').forEach((icon) => {
      let badge = icon.querySelector('.cart-count-bubble');
      if (!badge) { badge = document.createElement('div'); badge.className = 'cart-count-bubble'; icon.append(badge); }
      badge.textContent = String(cart.item_count);
      badge.hidden = cart.item_count === 0;
      icon.setAttribute('aria-label', 'Cart (' + cart.item_count + ')');
    });
  };
  const refresh = async (keepOpen = true) => {
    const sectionId = drawer()?.dataset.sectionId || 'cart-drawer';
    const page = document.querySelector('[data-replica-cart-section]');
    const pageSectionId = page?.dataset.replicaCartSection;
    const pageForm = page?.querySelector('.replica-cart__form');
    if (pageForm) pageForm.dataset.cartStale = 'true';
    const url = new URL(cartURL(), location.origin);
    url.searchParams.set('sections', [sectionId, pageSectionId].filter(Boolean).join(','));
    const [sectionResponse, cartResponse] = await Promise.all([
      fetch(url, { credentials: 'same-origin', cache: 'no-store' }),
      fetch(cartURL() + '.js', { credentials: 'same-origin', cache: 'no-store' })
    ]);
    if (!sectionResponse.ok || !cartResponse.ok) throw new Error('Unable to refresh your bag. Please try again.');
    const sections = await sectionResponse.json();
    const cart = await cartResponse.json();
    const parsed = new DOMParser().parseFromString(sections[sectionId] || '', 'text/html');
    const inner = parsed.querySelector('#CartDrawer');
    if (!inner) throw new Error('Cart files are incomplete. Please reload the page.');
    drawer().querySelector('#CartDrawer').replaceWith(inner);
    drawer().classList.toggle('is-empty', cart.item_count === 0);
    updateCount(cart);
    if (pageSectionId) {
      const pageDocument = new DOMParser().parseFromString(sections[pageSectionId] || '', 'text/html');
      const updatedPage = pageDocument.querySelector('[data-replica-cart-section]');
      if (!updatedPage) throw new Error('Your bag was updated, but the cart page could not refresh. Please reload this page before making more changes.');
      page.replaceWith(updatedPage);
      const recommendations = updatedPage.querySelector('.replica-page-recommendations');
      if (recommendations) loadRecommendations(recommendations);
    }
    loadRecommendations();
    if (keepOpen) open();
    return cart;
  };
  const mutate = async (path, body) => {
    if (busy) return;
    busy = true;
    drawer()?.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(result.description || 'Unable to update your bag.');
      await refresh(true);
    } catch (error) { showError(error); }
    finally { busy = false; drawer()?.removeAttribute('aria-busy'); }
  };
  const prepareCheckout = (event, form) => {
    if (busy || document.querySelector('.replica-cart__form.is-loading') || !form) {
      stop(event);
      return;
    }
    // Do not send stale page quantities after changing the drawer.
    if (form.dataset.cartStale === 'true') form.querySelectorAll('[name="updates[]"]').forEach((input) => { input.disabled = true; });
    // Let payment apps receive click/submit and cancel native checkout if needed.
  };
  // Run before legacy target listeners so one interaction sends one request.
  window.addEventListener('click', (event) => {
    const target = event.target.closest?.('a, button, #CartDrawer-Overlay');
    if (!target || !drawer()) return;
    if (isCartTrigger(target)) { stop(event); open(target); refresh(true).catch(showError); return; }
    if (target.matches('.replica-cart__checkout')) { prepareCheckout(event, target.form || target.closest('form')); return; }
    const recommendations = target.closest('.replica-page-recommendations');
    if (recommendations && target.hasAttribute('data-recommendations-retry')) { stop(event); loadRecommendations(recommendations); return; }
    if (recommendations && target.dataset.railDirection) { stop(event); recommendations.querySelector('.replica-drawer__rail')?.scrollBy({ left: Number(target.dataset.railDirection) * 240, behavior: 'smooth' }); return; }
    if (!target.closest('.replica-cart-controller')) return;
    if (target.hasAttribute('data-recommendations-retry')) { stop(event); loadRecommendations(); return; }
    if (target.matches('.replica-drawer__close, #CartDrawer-Overlay')) { stop(event); close(); return; }
    if (target.matches('.replica-drawer__checkout')) { prepareCheckout(event, target.form || document.getElementById('CartDrawer-Form')); return; }
    if (target.dataset.railDirection) { stop(event); drawer().querySelector('.replica-drawer__rail')?.scrollBy({ left: Number(target.dataset.railDirection) * 156, behavior: 'smooth' }); return; }
    const item = target.closest('[data-index].replica-drawer__item');
    if (!item) return;
    if (target.matches('.replica-drawer__remove, .quantity__button')) {
      stop(event);
      const input = item.querySelector('input[name="updates[]"]');
      let quantity = 0;
      if (!target.matches('.replica-drawer__remove')) {
        const value = Number(input.value), step = Number(input.step) || 1, min = Number(input.min) || 1;
        quantity = target.name === 'plus' ? value + step : value <= min ? 0 : Math.max(min, value - step);
        if (input.max && quantity > Number(input.max)) return;
      }
      mutate(cartURL() + '/change.js', { line: Number(item.dataset.index), quantity });
    }
  }, true);
  window.addEventListener('change', (event) => {
    const input = event.target;
    if (!input.matches('.replica-cart-controller input[name="updates[]"]')) return;
    stop(event);
    const quantity = Number(input.value);
    if (!Number.isInteger(quantity) || quantity < 0) { input.value = input.defaultValue; return; }
    mutate(cartURL() + '/change.js', { line: Number(input.dataset.index), quantity });
  }, true);
  window.addEventListener('submit', (event) => {
    const form = event.target;
    if (form.matches('[data-replica-drawer-add]')) {
      if (!drawer()) return;
      stop(event);
      mutate(cartURL() + '/add.js', { items: [{ id: Number(new FormData(form).get('id')), quantity: 1 }] });
    } else if (form.id === 'CartDrawer-Form' || form.matches('.replica-cart__form')) {
      if (event.submitter && !event.submitter.matches('[name="checkout"]')) { stop(event); return; }
      prepareCheckout(event, form);
    }
  }, true);
  window.addEventListener('keydown', (event) => {
    const root = drawer();
    if (!root?.classList.contains('active')) return;
    if (event.key === 'Enter' && event.target.matches('.replica-cart-controller input[name="updates[]"]')) {
      stop(event);
      const quantity = Number(event.target.value);
      if (Number.isInteger(quantity) && quantity >= 0) mutate(cartURL() + '/change.js', { line: Number(event.target.dataset.index), quantity });
      return;
    }
    if (event.key === 'Escape') { stop(event); close(); }
    if (event.key === 'Tab') {
      const nodes = [...root.querySelectorAll('a[href],button,input,[tabindex="0"]')].filter((node) => !node.disabled && node.getClientRects().length);
      const first = nodes[0], last = nodes[nodes.length - 1];
      if (event.shiftKey && document.activeElement === first) { stop(event); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { stop(event); first?.focus(); }
    }
  }, true);
  const connect = () => {
    document.querySelectorAll('.replica-page-recommendations').forEach(loadRecommendations);
    const root = drawer();
    if (!root) return;
    // Preserve the API used by existing product forms without its header assumptions.
    root.open = open;
    root.close = close;
    root.setActiveElement = (element) => { opener = element; };
    root.getSectionsToRender = () => [{ id: 'CartDrawer', section: root.dataset.sectionId || 'cart-drawer', selector: '#CartDrawer' }];
    root.renderContents = () => refresh(true).catch(showError);
    root.getUpsellHandles = () => [];
    root.checkForClear = () => {};
    loadRecommendations();
  };
  connect();
  document.addEventListener('DOMContentLoaded', connect);
  document.addEventListener('shopify:section:load', connect);
  document.addEventListener('cart:refresh', () => { if (drawer()) refresh(true).catch(showError); });
  document.addEventListener('shopify:section:select', (event) => {
    if (event.target.querySelector?.('.replica-cart-controller')) open();
  });
  document.addEventListener('shopify:section:deselect', (event) => {
    if (event.target.querySelector?.('.replica-cart-controller')) close();
  });
})();
